import React from 'react';

import { IIconProps, TIconType } from '../interface';

const DecreaseIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='5'
			viewBox='0 0 10 5'
			width='10'
		>
			<path
				d='M0.101076 0.547654L4.75769 4.90604C4.89154 5.03132 5.10856 5.03132 5.24241 4.90604L9.8989 0.547654C10.1148 0.345546 9.96197 0 9.65651 0H0.343444C0.0380781 0 -0.114844 0.345559 0.101076 0.547654Z'
				fill={props?.color || '#2E2E6B'}
			/>
		</svg>
	);
};

export default DecreaseIcon;
